import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../../components/text/text';
import { ElementOrIcon } from '../../elementOrIcon/elementOrIcon';
import { TextComponentType } from '../../text/types/component';
import { CheckboxIsErrorStyled } from '../checkbox.styled';
/**
 * CheckboxErrorStandAlone
 * @param {string} id - id of the checkbox
 * @param {string} dataTestId - data test id of the checkbox
 * @param {CheckboxPropsStylesType} styles - styles of the checkbox
 * @param {string} errorIcon - error icon of the checkbox
 * @param {string} errorAriaLiveType - error aria live type of the checkbox
 * @param {boolean} hasError - has error of the checkbox
 * @param {string} textError - text error of the checkbox
 * @returns {JSX.Element}
 */
export const CheckboxErrorStandAlone = ({ id, dataTestId, styles, errorIcon, errorAriaLiveType, error, errorMessage, }) => (_jsx(CheckboxIsErrorStyled, { "aria-live": errorAriaLiveType, id: id, styles: styles, children: error && errorMessage?.content && (_jsxs(_Fragment, { children: [_jsx(ElementOrIcon, { customIconStyles: styles?.errorIcon, ...errorIcon }), _jsx(Text, { component: TextComponentType.SPAN, customTypography: styles?.textError, dataTestId: dataTestId, ...errorMessage, children: errorMessage.content })] })) }));
//# sourceMappingURL=checkboxErrorStandAlone.js.map